import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SharedModule } from "@shared/shared.module";

@Component({
  selector: "app-help-center",
  templateUrl: "./help-center.component.html",
  styleUrls: ["./help-center.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, SharedModule],
})
export class HelpCenterComponent implements OnInit {
  expandedSections: Set<string> = new Set(["getting-started"]);
  expandedStages: Set<string> = new Set();

  ngOnInit(): void {
    // Handle deep links
    const hash = window.location.hash.substring(1);
    if (hash) {
      this.expandedSections.add(hash);
    }
  }

  toggleSection(sectionId: string): void {
    if (this.expandedSections.has(sectionId)) {
      this.expandedSections.delete(sectionId);
    } else {
      this.expandedSections.add(sectionId);
    }
  }

  isSectionExpanded(sectionId: string): boolean {
    return this.expandedSections.has(sectionId);
  }

  toggleStage(stageId: string, event: Event): void {
    event.stopPropagation();
    if (this.expandedStages.has(stageId)) {
      this.expandedStages.delete(stageId);
    } else {
      this.expandedStages.add(stageId);
    }
  }

  isStageExpanded(stageId: string): boolean {
    return this.expandedStages.has(stageId);
  }

  navigateToSection(sectionId: string): void {
    this.expandedSections.add(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
